import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["id"],
  _excluded2 = ["id"],
  _excluded3 = ["id", "focus"];
var _xe;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import I, { createContext as X, createRef as ue, useContext as Y, useEffect as q, useMemo as D, useReducer as me, useRef as V, useState as ie } from "react";
import { match as _2 } from '../../utils/match.js';
import { forwardRefWithAs as $, render as J, Features as z } from '../../utils/render.js';
import { optionalRef as ye, useSyncRefs as U } from '../../hooks/use-sync-refs.js';
import { useId as K } from '../../hooks/use-id.js';
import { Keys as k } from '../keyboard.js';
import { isDisabledReactIssue7711 as fe } from '../../utils/bugs.js';
import { getFocusableElements as ee, Focus as h, focusIn as w, isFocusableElement as Ee, FocusableMode as ge, FocusResult as te } from '../../utils/focus-management.js';
import { OpenClosedProvider as be, State as W, useOpenClosed as Pe } from '../../internal/open-closed.js';
import { useResolveButtonType as Se } from '../../hooks/use-resolve-button-type.js';
import { useOutsideClick as Ae } from '../../hooks/use-outside-click.js';
import { getOwnerDocument as Re } from '../../utils/owner.js';
import { useOwnerDocument as oe } from '../../hooks/use-owner.js';
import { useEventListener as Oe } from '../../hooks/use-event-listener.js';
import { Hidden as re, Features as ne } from '../../internal/hidden.js';
import { useEvent as b } from '../../hooks/use-event.js';
import { useTabDirection as de, Direction as H } from '../../hooks/use-tab-direction.js';
import '../../utils/micro-task.js';
import { useLatestValue as ce } from '../../hooks/use-latest-value.js';
import { useIsoMorphicEffect as Ce } from '../../hooks/use-iso-morphic-effect.js';
var Fe = function (s) {
    return s[s.Open = 0] = "Open", s[s.Closed = 1] = "Closed", s;
  }(Fe || {}),
  Ie = function (t) {
    return t[t.TogglePopover = 0] = "TogglePopover", t[t.ClosePopover = 1] = "ClosePopover", t[t.SetButton = 2] = "SetButton", t[t.SetButtonId = 3] = "SetButtonId", t[t.SetPanel = 4] = "SetPanel", t[t.SetPanelId = 5] = "SetPanelId", t;
  }(Ie || {});
var xe = (_xe = {}, _defineProperty(_xe, 0, function _(o) {
    var _3;
    return _objectSpread(_objectSpread({}, o), {}, {
      popoverState: _2(o.popoverState, (_3 = {}, _defineProperty(_3, 0, 1), _defineProperty(_3, 1, 0), _3))
    });
  }), _defineProperty(_xe, 1, function _(o) {
    return o.popoverState === 1 ? o : _objectSpread(_objectSpread({}, o), {}, {
      popoverState: 1
    });
  }), _defineProperty(_xe, 2, function _(o, l) {
    return o.button === l.button ? o : _objectSpread(_objectSpread({}, o), {}, {
      button: l.button
    });
  }), _defineProperty(_xe, 3, function _(o, l) {
    return o.buttonId === l.buttonId ? o : _objectSpread(_objectSpread({}, o), {}, {
      buttonId: l.buttonId
    });
  }), _defineProperty(_xe, 4, function _(o, l) {
    return o.panel === l.panel ? o : _objectSpread(_objectSpread({}, o), {}, {
      panel: l.panel
    });
  }), _defineProperty(_xe, 5, function _(o, l) {
    return o.panelId === l.panelId ? o : _objectSpread(_objectSpread({}, o), {}, {
      panelId: l.panelId
    });
  }), _xe),
  le = X(null);
le.displayName = "PopoverContext";
function Q(o) {
  var l = Y(le);
  if (l === null) {
    var s = new Error("<".concat(o, " /> is missing a parent <Popover /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(s, Q), s;
  }
  return l;
}
var ae = X(null);
ae.displayName = "PopoverAPIContext";
function pe(o) {
  var l = Y(ae);
  if (l === null) {
    var s = new Error("<".concat(o, " /> is missing a parent <Popover /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(s, pe), s;
  }
  return l;
}
var se = X(null);
se.displayName = "PopoverGroupContext";
function ve() {
  return Y(se);
}
var Z = X(null);
Z.displayName = "PopoverPanelContext";
function Le() {
  return Y(Z);
}
function Me(o, l) {
  return _2(l.type, xe, o, l);
}
var Be = "div";
function De(o, l) {
  var _4;
  var B;
  var s = V(null),
    R = U(l, ye(function (e) {
      s.current = e;
    })),
    C = V([]),
    r = me(Me, {
      popoverState: 1,
      buttons: C,
      button: null,
      buttonId: null,
      panel: null,
      panelId: null,
      beforePanelSentinel: ue(),
      afterPanelSentinel: ue()
    }),
    _r = _slicedToArray(r, 2),
    _r$ = _r[0],
    t = _r$.popoverState,
    a = _r$.button,
    v = _r$.buttonId,
    f = _r$.panel,
    F = _r$.panelId,
    T = _r$.beforePanelSentinel,
    d = _r$.afterPanelSentinel,
    i = _r[1],
    p = oe((B = s.current) != null ? B : a),
    P = D(function () {
      if (!a || !f) return !1;
      var _iterator = _createForOfIteratorHelper(document.querySelectorAll("body > *")),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var N = _step.value;
          if (Number(N == null ? void 0 : N.contains(a)) ^ Number(N == null ? void 0 : N.contains(f))) return !0;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var e = ee(),
        n = e.indexOf(a),
        A = (n + e.length - 1) % e.length,
        g = (n + 1) % e.length,
        G = e[A],
        Te = e[g];
      return !f.contains(G) && !f.contains(Te);
    }, [a, f]),
    S = ce(v),
    y = ce(F),
    x = D(function () {
      return {
        buttonId: S,
        panelId: y,
        close: function close() {
          return i({
            type: 1
          });
        }
      };
    }, [S, y, i]),
    O = ve(),
    L = O == null ? void 0 : O.registerPopover,
    j = b(function () {
      var e;
      return (e = O == null ? void 0 : O.isFocusWithinPopoverGroup()) != null ? e : (p == null ? void 0 : p.activeElement) && ((a == null ? void 0 : a.contains(p.activeElement)) || (f == null ? void 0 : f.contains(p.activeElement)));
    });
  q(function () {
    return L == null ? void 0 : L(x);
  }, [L, x]), Oe(p == null ? void 0 : p.defaultView, "focus", function (e) {
    var n, A, g, G;
    t === 0 && (j() || a && f && e.target !== window && ((A = (n = T.current) == null ? void 0 : n.contains) != null && A.call(n, e.target) || (G = (g = d.current) == null ? void 0 : g.contains) != null && G.call(g, e.target) || i({
      type: 1
    })));
  }, !0), Ae([a, f], function (e, n) {
    i({
      type: 1
    }), Ee(n, ge.Loose) || (e.preventDefault(), a == null || a.focus());
  }, t === 0);
  var M = b(function (e) {
      i({
        type: 1
      });
      var n = function () {
        return e ? e instanceof HTMLElement ? e : "current" in e && e.current instanceof HTMLElement ? e.current : a : a;
      }();
      n == null || n.focus();
    }),
    u = D(function () {
      return {
        close: M,
        isPortalled: P
      };
    }, [M, P]),
    m = D(function () {
      return {
        open: t === 0,
        close: M
      };
    }, [t, M]),
    E = o,
    c = {
      ref: R
    };
  return I.createElement(Z.Provider, {
    value: null
  }, I.createElement(le.Provider, {
    value: r
  }, I.createElement(ae.Provider, {
    value: u
  }, I.createElement(be, {
    value: _2(t, (_4 = {}, _defineProperty(_4, 0, W.Open), _defineProperty(_4, 1, W.Closed), _4))
  }, J({
    ourProps: c,
    theirProps: E,
    slot: m,
    defaultTag: Be,
    name: "Popover"
  })))));
}
var he = "button";
function He(o, l) {
  var s = K(),
    _o$id = o.id,
    R = _o$id === void 0 ? "headlessui-popover-button-".concat(s) : _o$id,
    C = _objectWithoutProperties(o, _excluded),
    _Q = Q("Popover.Button"),
    _Q2 = _slicedToArray(_Q, 2),
    r = _Q2[0],
    t = _Q2[1],
    _pe = pe("Popover.Button"),
    a = _pe.isPortalled,
    v = V(null),
    f = "headlessui-focus-sentinel-".concat(K()),
    F = ve(),
    T = F == null ? void 0 : F.closeOthers,
    i = Le() !== null;
  q(function () {
    if (!i) return t({
      type: 3,
      buttonId: R
    }), function () {
      t({
        type: 3,
        buttonId: null
      });
    };
  }, [i, R, t]);
  var _ie = ie(function () {
      return Symbol();
    }),
    _ie2 = _slicedToArray(_ie, 1),
    p = _ie2[0],
    P = U(v, l, i ? null : function (e) {
      if (e) r.buttons.current.push(p);else {
        var n = r.buttons.current.indexOf(p);
        n !== -1 && r.buttons.current.splice(n, 1);
      }
      r.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), e && t({
        type: 2,
        button: e
      });
    }),
    S = U(v, l),
    y = oe(v),
    x = b(function (e) {
      var n, A, g;
      if (i) {
        if (r.popoverState === 1) return;
        switch (e.key) {
          case k.Space:
          case k.Enter:
            e.preventDefault(), (A = (n = e.target).click) == null || A.call(n), t({
              type: 1
            }), (g = r.button) == null || g.focus();
            break;
        }
      } else switch (e.key) {
        case k.Space:
        case k.Enter:
          e.preventDefault(), e.stopPropagation(), r.popoverState === 1 && (T == null || T(r.buttonId)), t({
            type: 0
          });
          break;
        case k.Escape:
          if (r.popoverState !== 0) return T == null ? void 0 : T(r.buttonId);
          if (!v.current || y != null && y.activeElement && !v.current.contains(y.activeElement)) return;
          e.preventDefault(), e.stopPropagation(), t({
            type: 1
          });
          break;
      }
    }),
    O = b(function (e) {
      i || e.key === k.Space && e.preventDefault();
    }),
    L = b(function (e) {
      var n, A;
      fe(e.currentTarget) || o.disabled || (i ? (t({
        type: 1
      }), (n = r.button) == null || n.focus()) : (e.preventDefault(), e.stopPropagation(), r.popoverState === 1 && (T == null || T(r.buttonId)), t({
        type: 0
      }), (A = r.button) == null || A.focus()));
    }),
    j = b(function (e) {
      e.preventDefault(), e.stopPropagation();
    }),
    M = r.popoverState === 0,
    u = D(function () {
      return {
        open: M
      };
    }, [M]),
    m = Se(o, v),
    E = i ? {
      ref: S,
      type: m,
      onKeyDown: x,
      onClick: L
    } : {
      ref: P,
      id: r.buttonId,
      type: m,
      "aria-expanded": o.disabled ? void 0 : r.popoverState === 0,
      "aria-controls": r.panel ? r.panelId : void 0,
      onKeyDown: x,
      onKeyUp: O,
      onClick: L,
      onMouseDown: j
    },
    c = de(),
    B = b(function () {
      var e = r.panel;
      if (!e) return;
      function n() {
        var _5, _6;
        _2(c.current, (_5 = {}, _defineProperty(_5, H.Forwards, function () {
          return w(e, h.First);
        }), _defineProperty(_5, H.Backwards, function () {
          return w(e, h.Last);
        }), _5)) === te.Error && w(ee().filter(function (g) {
          return g.dataset.headlessuiFocusGuard !== "true";
        }), _2(c.current, (_6 = {}, _defineProperty(_6, H.Forwards, h.Next), _defineProperty(_6, H.Backwards, h.Previous), _6)), {
          relativeTo: r.button
        });
      }
      n();
    });
  return I.createElement(I.Fragment, null, J({
    ourProps: E,
    theirProps: C,
    slot: u,
    defaultTag: he,
    name: "Popover.Button"
  }), M && !i && a && I.createElement(re, {
    id: f,
    features: ne.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: B
  }));
}
var Ge = "div",
  _e = z.RenderStrategy | z.Static;
function ke(o, l) {
  var s = K(),
    _o$id2 = o.id,
    R = _o$id2 === void 0 ? "headlessui-popover-overlay-".concat(s) : _o$id2,
    C = _objectWithoutProperties(o, _excluded2),
    _Q3 = Q("Popover.Overlay"),
    _Q4 = _slicedToArray(_Q3, 2),
    r = _Q4[0].popoverState,
    t = _Q4[1],
    a = U(l),
    v = Pe(),
    f = function () {
      return v !== null ? (v & W.Open) === W.Open : r === 0;
    }(),
    F = b(function (i) {
      if (fe(i.currentTarget)) return i.preventDefault();
      t({
        type: 1
      });
    }),
    T = D(function () {
      return {
        open: r === 0
      };
    }, [r]);
  return J({
    ourProps: {
      ref: a,
      id: R,
      "aria-hidden": !0,
      onClick: F
    },
    theirProps: C,
    slot: T,
    defaultTag: Ge,
    features: _e,
    visible: f,
    name: "Popover.Overlay"
  });
}
var we = "div",
  Ne = z.RenderStrategy | z.Static;
function Ue(o, l) {
  var s = K(),
    _o$id3 = o.id,
    R = _o$id3 === void 0 ? "headlessui-popover-panel-".concat(s) : _o$id3,
    _o$focus = o.focus,
    C = _o$focus === void 0 ? !1 : _o$focus,
    r = _objectWithoutProperties(o, _excluded3),
    _Q5 = Q("Popover.Panel"),
    _Q6 = _slicedToArray(_Q5, 2),
    t = _Q6[0],
    a = _Q6[1],
    _pe2 = pe("Popover.Panel"),
    v = _pe2.close,
    f = _pe2.isPortalled,
    F = "headlessui-focus-sentinel-before-".concat(K()),
    T = "headlessui-focus-sentinel-after-".concat(K()),
    d = V(null),
    i = U(d, l, function (u) {
      a({
        type: 4,
        panel: u
      });
    }),
    p = oe(d);
  Ce(function () {
    return a({
      type: 5,
      panelId: R
    }), function () {
      a({
        type: 5,
        panelId: null
      });
    };
  }, [R, a]);
  var P = Pe(),
    S = function () {
      return P !== null ? (P & W.Open) === W.Open : t.popoverState === 0;
    }(),
    y = b(function (u) {
      var m;
      switch (u.key) {
        case k.Escape:
          if (t.popoverState !== 0 || !d.current || p != null && p.activeElement && !d.current.contains(p.activeElement)) return;
          u.preventDefault(), u.stopPropagation(), a({
            type: 1
          }), (m = t.button) == null || m.focus();
          break;
      }
    });
  q(function () {
    var u;
    o.static || t.popoverState === 1 && ((u = o.unmount) == null || u) && a({
      type: 4,
      panel: null
    });
  }, [t.popoverState, o.unmount, o.static, a]), q(function () {
    if (!C || t.popoverState !== 0 || !d.current) return;
    var u = p == null ? void 0 : p.activeElement;
    d.current.contains(u) || w(d.current, h.First);
  }, [C, d, t.popoverState]);
  var x = D(function () {
      return {
        open: t.popoverState === 0,
        close: v
      };
    }, [t, v]),
    O = {
      ref: i,
      id: R,
      onKeyDown: y,
      onBlur: C && t.popoverState === 0 ? function (u) {
        var E, c, B, e, n;
        var m = u.relatedTarget;
        m && d.current && ((E = d.current) != null && E.contains(m) || (a({
          type: 1
        }), ((B = (c = t.beforePanelSentinel.current) == null ? void 0 : c.contains) != null && B.call(c, m) || (n = (e = t.afterPanelSentinel.current) == null ? void 0 : e.contains) != null && n.call(e, m)) && m.focus({
          preventScroll: !0
        })));
      } : void 0,
      tabIndex: -1
    },
    L = de(),
    j = b(function () {
      var u = d.current;
      if (!u) return;
      function m() {
        var _7;
        _2(L.current, (_7 = {}, _defineProperty(_7, H.Forwards, function () {
          var c;
          w(u, h.First) === te.Error && ((c = t.afterPanelSentinel.current) == null || c.focus());
        }), _defineProperty(_7, H.Backwards, function () {
          var E;
          (E = t.button) == null || E.focus({
            preventScroll: !0
          });
        }), _7));
      }
      m();
    }),
    M = b(function () {
      var u = d.current;
      if (!u) return;
      function m() {
        var _8;
        _2(L.current, (_8 = {}, _defineProperty(_8, H.Forwards, function () {
          var A;
          if (!t.button) return;
          var E = ee(),
            c = E.indexOf(t.button),
            B = E.slice(0, c + 1),
            n = [].concat(_toConsumableArray(E.slice(c + 1)), _toConsumableArray(B));
          var _iterator2 = _createForOfIteratorHelper(n.slice()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var g = _step2.value;
              if (g.dataset.headlessuiFocusGuard === "true" || (A = t.panel) != null && A.contains(g)) {
                var G = n.indexOf(g);
                G !== -1 && n.splice(G, 1);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          w(n, h.First, {
            sorted: !1
          });
        }), _defineProperty(_8, H.Backwards, function () {
          var c;
          w(u, h.Previous) === te.Error && ((c = t.button) == null || c.focus());
        }), _8));
      }
      m();
    });
  return I.createElement(Z.Provider, {
    value: R
  }, S && f && I.createElement(re, {
    id: F,
    ref: t.beforePanelSentinel,
    features: ne.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: j
  }), J({
    ourProps: O,
    theirProps: r,
    slot: x,
    defaultTag: we,
    features: Ne,
    visible: S,
    name: "Popover.Panel"
  }), S && f && I.createElement(re, {
    id: T,
    ref: t.afterPanelSentinel,
    features: ne.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: M
  }));
}
var Ke = "div";
function We(o, l) {
  var s = V(null),
    R = U(s, l),
    _ie3 = ie([]),
    _ie4 = _slicedToArray(_ie3, 2),
    C = _ie4[0],
    r = _ie4[1],
    t = b(function (p) {
      r(function (P) {
        var S = P.indexOf(p);
        if (S !== -1) {
          var y = P.slice();
          return y.splice(S, 1), y;
        }
        return P;
      });
    }),
    a = b(function (p) {
      return r(function (P) {
        return [].concat(_toConsumableArray(P), [p]);
      }), function () {
        return t(p);
      };
    }),
    v = b(function () {
      var S;
      var p = Re(s);
      if (!p) return !1;
      var P = p.activeElement;
      return (S = s.current) != null && S.contains(P) ? !0 : C.some(function (y) {
        var x, O;
        return ((x = p.getElementById(y.buttonId.current)) == null ? void 0 : x.contains(P)) || ((O = p.getElementById(y.panelId.current)) == null ? void 0 : O.contains(P));
      });
    }),
    f = b(function (p) {
      var _iterator3 = _createForOfIteratorHelper(C),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var P = _step3.value;
          P.buttonId.current !== p && P.close();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }),
    F = D(function () {
      return {
        registerPopover: a,
        unregisterPopover: t,
        isFocusWithinPopoverGroup: v,
        closeOthers: f
      };
    }, [a, t, v, f]),
    T = D(function () {
      return {};
    }, []),
    d = o,
    i = {
      ref: R
    };
  return I.createElement(se.Provider, {
    value: F
  }, J({
    ourProps: i,
    theirProps: d,
    slot: T,
    defaultTag: Ke,
    name: "Popover.Group"
  }));
}
var je = $(De),
  Ve = $(He),
  $e = $(ke),
  Je = $(Ue),
  Xe = $(We),
  Lt = Object.assign(je, {
    Button: Ve,
    Overlay: $e,
    Panel: Je,
    Group: Xe
  });
export { Lt as Popover };